export const WEB_EVENTS = {
	UUID: 'get_uuid',
} as const;
